module.exports = __webpack_public_path__ + "static/media/food-orders.d3caf95f.jpg";